import { Config } from '~/stores/configStore';

export default async function (config: Config[]): Promise<boolean> {
  const configStore = useConfigStore();
  await configStore.fetchConfig();
  return config.every((config) => configStore.config?.[config]);
}
